export default __webpack_public_path__ + "media/images/footer-logo-71aac9d6f431cceb87d49780cd19c1f2.svg";